import { Avatar, makeStyles } from "@material-ui/core";
import cn from "classnames";
import Logo from "images/nav-bar/mojo-white-tiger-logo.svg?react";
import React from "react";
import { NavLink } from "react-router-dom";
import styleHelper from "utils/styleHelper";
import CreateNewButton from "./CreateNewButton";
import { clickedOn } from "./commonUtils";

const useStyles = makeStyles((theme) => ({
  createNewButton: {
    marginLeft: 12,
  },
  wrapper: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
  },
  logo: {
    border: "none !important",
    width: "40px !important",
    height: "40px !important",
    marginRight: "12px",
    backgroundColor: "transparent !important",
    overflow: "unset !important",
  },
  prideLogo: {
    marginTop: -12,
  },
  hideTablet: {
    [styleHelper.tablet]: {
      display: "none",
    },
  },

  link: {
    cursor: "pointer",
    margin: "0 12px",
    fontFamily: "Larsseit",
    lineHeight: "1", // TODO: come back to this
    color: theme.colors.cornflower,
    "&:hover": {
      fontSize: "14px",
      fontWeight: "bold",
      color: theme.colors.white,
    },
  },
  proximaLink: {
    color: theme.colors.proxima.aqua,
  },
}));

function NavBarMainMenu() {
  const classes = useStyles();
  const currentMonth = new Date().getMonth();
  const isPrideMonth = currentMonth === 5;
  const navItems = [
    {
      to: "/",
      content: (
        <Avatar classes={{ colorDefault: classes.logo }}>
          {isPrideMonth ? (
            <img
              alt="PrideMojo"
              src="/images/nav-bar/pride/mojo-pride.png"
              srcSet="/images/nav-bar/pride/mojo-pride.png, /images/nav-bar/pride/mojo-pride@2x.png 2x, /images/nav-bar/pride/mojo-pride@3x.png 3x"
              className={classes.prideLogo}
            />
          ) : (
            <Logo />
          )}
        </Avatar>
      ),
      noClasses: true,
      clickedOn: "Dojo Icon",
    },
    {
      to: "/search",
      content: "Discover",
      exact: true,
    },
    {
      to: "/sweepstakes",
      content: "Sweepstakes",
    },
  ].filter(Boolean);

  const generateLink = (item) => {
    const linkClasses = item.noClasses ? null : cn(classes.link, classes.hideTablet);
    const activeStyles = item.noClasses
      ? {}
      : {
          fontWeight: "bold",
          color: "white",
        };

    if (item.external) {
      return (
        <a
          key={item.clickedOn || item.content}
          href={item.to}
          className={linkClasses}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => clickedOn("", item.clickedOn)}
        >
          {item.content}
        </a>
      );
    }

    return (
      <NavLink
        key={item.clickedOn || item.content}
        exact={item.exact}
        to={item.to}
        className={linkClasses}
        activeStyle={activeStyles}
        onClick={() => clickedOn("", item.clickedOn)}
      >
        {item.content}
      </NavLink>
    );
  };

  return (
    <div className={classes.wrapper}>
      {navItems.map(generateLink)}
      <div className={cn(classes.createNewButton, classes.hideTablet)}>
        <CreateNewButton />
      </div>
    </div>
  );
}

export default React.memo(NavBarMainMenu);
